
export var postChannelGQLQuery = `
  postChannelTree:JSON
`

export var postChannelGQLMutation = `
  savePostChannelTree(tree:JSON):JSON
`